var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRankingArrow = function SvgRankingArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.566 1.26A.762.762 0 0 0 13 1a.762.762 0 0 0-.566.26L7.395 6.854 2.357 1.26a.746.746 0 0 0-.768-.218.85.85 0 0 0-.56.623.96.96 0 0 0 .196.852L6.829 8.74c.15.166.354.26.566.26a.762.762 0 0 0 .566-.26l5.605-6.223a.94.94 0 0 0 .234-.628.94.94 0 0 0-.234-.629Z",
    fill: "#212121",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeWidth: 0.4
  })));
};
export default SvgRankingArrow;